import type { PostHogConfig } from "posthog-js";
export const apiUrl = "/api";
export const bucketUrl =
  import.meta.env.VITE_STORAGE_URL || "https://storage.hometoq.com/images";

// PostHog configuration
export const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
export const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

export const posthogOptions: Partial<PostHogConfig> = {
  api_host: posthogHost,
  capture_exceptions: true, // capture exceptions via Error Tracking
  debug: import.meta.env.MODE === "development",
  defaults: "2025-05-24", // default values for PostHog
};
